import { Navigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { Box, CircularProgress } from '@mui/material'
import { isSuperAdmin } from '../../lib/roles'
import { roleHomePath } from '../../lib/roleHomePath'

/**
 * Restricts access to super admins only (super_admin role, no tenant).
 * Non–super-admins are redirected to their home portal.
 */
export const SuperAdminRoute = ({ children }) => {
  const { user, userProfile, loading, isViewingAsUser } = useAuth()

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (!user || !userProfile) {
    return <Navigate to="/login" replace />
  }

  if (userProfile.onboarding_complete === false) {
    return <Navigate to="/complete-onboarding" replace />
  }

  if (isViewingAsUser) {
    return <Navigate to={roleHomePath(userProfile)} replace />
  }

  if (!isSuperAdmin(userProfile)) {
    return <Navigate to="/admin" replace />
  }

  return children
}
